import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../Context/Context";
import { Link, useHistory } from "react-router-dom";

export const MenuLateral = () => {
    const [state, setState, setSelectedPlan, loadingPlanDetails] = useContext(AppContext);
    const [activePath, setActivePath] = useState(window.location.pathname);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
    const [isMobileMenuVisible, setIsMobileMenuVisible] = useState(false);
    const [activeExternalLink, setActiveExternalLink] = useState(null);
    const history = useHistory();

    const handlePlanSelection = (event) => {
        const selectedPlanId = event.target.value;
        const plan = state.planes.find(plan => plan.Id === selectedPlanId);
        if (plan) {
            setSelectedPlan(plan);
        } else {
            console.error("Selected plan not found.");
        }

        if (isMobile) {
            setIsMobileMenuVisible(false);
        }
    };

    const handleCerrarSesion = () => {
        sessionStorage.clear();
        history.push('/');
    };

    useEffect(() => {
        if (state.data) {
            setState(prevState => ({ ...prevState, planes: state.data.Usuario.Datos.Planes.Plan }));
        }
    }, [state.data, setState]);

    useEffect(() => {
        const unlisten = history.listen((location) => {
            setActivePath(location.pathname);
        });
        return () => unlisten();
    }, [history]);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const toggleMobileMenu = () => {
        setIsMobileMenuVisible((prev) => !prev);
    };

    const isEasyTrackingVisible = state.easyTrackingEnabled;
    const isHaberNetoVisible = state.haberNetoEnabled && state.selectedPlan?.EstadoPlan === "Renunciado/Rescindido";
    const isSolicitudReintegroVisible = state.reintegroEnabled && state.reintegros.MuestraBoton;
    const isAhorrista = state.selectedPlan?.EstadoPlan === "Ahorrista";
    const isEnJuicio = state.selectedPlan?.EstadoPlan === "Adjudicado - EN JUICIO";
    const cargaOferta = state.cargaOferta
    const reintegroURL = state.reintegros.URL;
    const isReintegroURLValid = reintegroURL !== "";

    if (loadingPlanDetails) return <div className="sidebar"><div className="sidebar-header obteniendo-plan">Obteniendo Plan...</div></div>;

    return (
        <div className="sidebar">
            <div className="sidebar-header">
                <select
                    className="plan-dropdown"
                    value={state.selectedPlan?.Id || ""}
                    onChange={handlePlanSelection}
                    disabled={loadingPlanDetails}
                >
                    {state.planes.map(plan => {
                        const formattedId = `${plan.Grupo}/${plan.Orden}`;
                        return (
                            <option key={plan.Id} value={plan.Id}>
                                {plan.descripcion || formattedId}
                            </option>
                        );
                    })}
                </select>
                {isMobile && (
                    <button className="menu-toggle-button" onClick={toggleMobileMenu}>
                        <img src='/images/icons/menu.svg' alt="Toggle menu" />
                    </button>
                )}
            </div>
            {isMobile ? (
                isMobileMenuVisible && (
                    <div>
                        <div className="sidebar-menu">
                            <ul>
                                <li>
                                    <Link
                                        to="/inicio"
                                        className={`sidebar-link ${activePath === '/inicio' ? 'active' : ''}`}
                                        onClick={toggleMobileMenu}
                                    >
                                        INICIO
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/mis_datos"
                                        className={`sidebar-link ${activePath === '/mis_datos' ? 'active' : ''}`}
                                        onClick={toggleMobileMenu}
                                    >
                                        MIS DATOS
                                    </Link>
                                </li>
                                {!isEnJuicio && (
                                <li>
                                    <Link
                                        to="/cuotas"
                                        className={`sidebar-link ${activePath === '/cuotas' ? 'active' : ''}`}
                                        onClick={toggleMobileMenu}
                                    >
                                        CUOTAS
                                    </Link>
                                </li>
                                )}
                                {isEasyTrackingVisible && (
                                    <li>
                                        <Link
                                            to="/easy_tracking"
                                            className={`sidebar-link ${activePath === '/easy_tracking' ? 'active' : ''}`}
                                            onClick={toggleMobileMenu}
                                        >
                                            ESTADO DE MI PLAN
                                        </Link>
                                    </li>
                                )}
                                <li>
                                    <Link
                                        to="/instructivos"
                                        className={`sidebar-link ${activePath === '/instructivos' ? 'active' : ''}`}
                                        onClick={toggleMobileMenu}
                                    >
                                        INSTRUCTIVOS
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        to="/notificaciones"
                                        className={`sidebar-link ${activePath === '/notificaciones' ? 'active' : ''}`}
                                        onClick={toggleMobileMenu}
                                    >
                                        NOTIFICACIONES
                                    </Link>
                                </li>
                                {isSolicitudReintegroVisible && isReintegroURLValid &&(
                                    <li>
                                        <a
                                            href={reintegroURL}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={`sidebar-link ${activePath === reintegroURL ? 'active' : ''}`}
                                            onClick={toggleMobileMenu}
                                        >
                                            REINTEGROS
                                        </a>
                                    </li>
                                )
                                }
                                <li>
                                    <a
                                        onClick={() => {
                                            handleCerrarSesion();
                                            toggleMobileMenu();
                                        }}
                                        className="sidebar-link cerrar"
                                    >
                                        CERRAR SESIÓN
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="sidebar-info">
                            <p className="sidebar-info-data"><span className="sidebar-info-label">Tipo de plan:</span> <span className="sidebar-info-value">{state.planDetails?.TipoPlan || "N/A"}</span></p>
                            <p className="sidebar-info-data"><span className="sidebar-info-label">Modelo de ahorro:</span> <span className="sidebar-info-value">{state.planDetails?.ModeloAhorro || "N/A"}</span></p>
                            <p className="sidebar-info-data"><span className="sidebar-info-label">Estado de contrato:</span> <span className="sidebar-info-value">{state.planDetails?.EstadoPlan || "N/A"}</span></p>
                            <p className="sidebar-info-data"><span className="sidebar-info-label">Concesionario actual:</span> <span className="sidebar-info-value">{state.planDetails?.ConcesionarioActual || "N/A"}</span></p>
                        </div>
                    </div>
                )
            ) : (
                <div>
                    <div className="sidebar-menu">
                        <ul>
                            <li>
                                <Link to="/mis_datos" className={`sidebar-link ${activePath === '/mis_datos' ? 'active' : ''}`}>
                                    MIS DATOS
                                </Link>
                            </li>
                            {!isEnJuicio && (
                            <li>
                                <Link to="/cuotas" className={`sidebar-link ${activePath === '/cuotas' ? 'active' : ''}`}>
                                    CUOTAS
                                </Link>
                            </li>
                            )}
                            {isEasyTrackingVisible && (
                                <li>
                                    <Link to="/easy_tracking" className={`sidebar-link ${activePath === '/easy_tracking' ? 'active' : ''}`}>
                                        ESTADO DE MI PLAN
                                    </Link>
                                </li>
                            )}
                            {isHaberNetoVisible && (
                                <li>
                                    <Link to="/haber_neto" className={`sidebar-link ${activePath === '/haber_neto' ? 'active' : ''}`}>
                                        CONSULTA HABER NETO
                                    </Link>
                                </li>
                            )}
                            {isSolicitudReintegroVisible && isReintegroURLValid &&(
                                <li>
                                    <a
                                        href={reintegroURL}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={`sidebar-link ${activePath === reintegroURL ? 'active' : ''}`}
                                    >
                                        REINTEGROS
                                    </a>
                                </li>
                            )
                            }
                            {isAhorrista && (
                                <li>
                                    <a
                                        href={cargaOferta}
                                        target="_blank"
                                        className={`sidebar-link ${activeExternalLink === 'oferta' ? 'active' : ''}`}
                                        onClick={() => setActiveExternalLink('oferta')}
                                    >
                                        OFERTA DE LICITACIÓN
                                    </a>
                                </li>
                            )}
                        </ul>
                    </div>
                    <div className="sidebar-info">
                        <p className="sidebar-info-data"><span className="sidebar-info-label">Tipo de plan:</span> <span className="sidebar-info-value">{state.planDetails?.TipoPlan || "N/A"}</span></p>
                        <p className="sidebar-info-data"><span className="sidebar-info-label">Modelo de ahorro:</span> <span className="sidebar-info-value">{state.planDetails?.ModeloAhorro || "N/A"}</span></p>
                        <p className="sidebar-info-data"><span className="sidebar-info-label">Estado de contrato:</span> <span className="sidebar-info-value">{state.planDetails?.EstadoPlan || "N/A"}</span></p>
                        <p className="sidebar-info-data"><span className="sidebar-info-label">Concesionario actual:</span> <span className="sidebar-info-value">{state.planDetails?.ConcesionarioActual || "N/A"}</span></p>
                    </div>
                </div>
            )}
        </div>
    );

};
